export default __webpack_public_path__ + "static/slg-km2-c058822756181cc0c6792b44d19f8b2a.jpg";